module.exports = __webpack_public_path__ + "media/journey1-A.288c3a5c.mp4";